/* eslint-disable react/no-danger */
/**
 * Head for Flight Status PWA (mobile). Uses baseFlightStatusPWA.min.css for
 * flight status detail (StatusTitleCard, etc. – same as Flights-UI flightStatusDetail.css).
 */
import { getFontUrl } from "../../utils/helper/utils";
import { bankOfferCSS } from "../../utils/stylesUtil/bankOffer";
import { baseMinCss } from "../../utils/stylesUtil/baseMin";
import { commonHeaderCss } from "../../utils/stylesUtil/commonHeader";
import { flightsInlineCSSMob } from "../../utils/stylesUtil/flightsInlinecssMob";
import { footerMobCss } from "../../utils/stylesUtil/footerMobCss";
import { jqueryUIMinCss } from "../../utils/stylesUtil/jqueryUIMin";
import { seoBaseMin } from "../../utils/stylesUtil/seoBase";
import { seoFlightMobCss } from "../../utils/stylesUtil/seoFlightMob";
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";

export const appendHeadFlightStatusPWA = (props) => {
  const { appConfig = {}, language, isGoibibo = false, tokenJson } = props || {};
  let cssPath = "http://localhost:3000/_next/static/css";
  if (appConfig?.liveMode) {
    cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
  }
  const tokenJsonString =
    tokenJson && Object.keys(tokenJson).length !== 0
      ? `var tokenJson = ${JSON.stringify(tokenJson)};`
      : "var tokenJson = {};";

  return (
    <>
      <link href="https://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="http://imgak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://jsak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://cssak.mmtcdn.com" rel="preconnect" crossOrigin />
      <link href="https://bid.g.doubleclick.net" rel="preconnect" crossOrigin />
      <link href="http://makemytrip.tt.omtrdc.net" rel="preconnect" crossOrigin />
      <link href={`${cssPath}/bootstrap.min.css`} rel="stylesheet" />
      <style dangerouslySetInnerHTML={{ __html: seoBaseMin }} />
      <style dangerouslySetInnerHTML={{ __html: jqueryUIMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: commonHeaderCss }} />
      <style dangerouslySetInnerHTML={{ __html: bankOfferCSS }} />
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS }} />
      <style dangerouslySetInnerHTML={{ __html: baseMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: flightsInlineCSSMob }} />
      <link href={`${cssPath}/flightNewIndexLanding.min.css`} rel="stylesheet" />
      <style dangerouslySetInnerHTML={{ __html: seoFlightMobCss }} />
      <style dangerouslySetInnerHTML={{ __html: footerMobCss }} />
      <link href={`${cssPath}/baseFlightStatusPWA.min.css`} rel="stylesheet" />
      <script type="text/javascript" dangerouslySetInnerHTML={{ __html: tokenJsonString }} />
      <link
        rel="stylesheet"
        href={getFontUrl(language, isGoibibo)}
        as="style"
        onLoad="this.onload=null;this.rel='stylesheet'"
      />
    </>
  );
};
